<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">AWB Inscan</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
    <form>
        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-12">
                        <form [formGroup]="awbInscanForm">
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="mb-2">
                                        <label for="" class="form-label">Status <span class="mandatory">*</span></label>
                                        <ng-select formControlName="ddlStatus" [items]="statusList" bindLabel="name"
                                            [bindValue]="'id'" placeholder="Select"
                                            [ngClass]="{'is-invalid':(isFormSubmitted||awbInscanForm.get('ddlStatus').touched)&& awbInscanForm.get('ddlStatus').errors}">

                                        </ng-select>
                                        <div class="invalid-feedback"
                                            *ngIf="(isFormSubmitted||awbInscanForm.get('ddlStatus').touched)&& awbInscanForm.get('ddlStatus').errors">
                                            <span *ngIf="awbInscanForm.get('ddlStatus').errors.required">Status is
                                                Required</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="mb-2">
                                        <label for="" class="form-label">Remark</label>
                                        <input type="text" class="form-control form-control-sm"
                                            formControlName="txtRemark" placeholder="Type to search"
                                            [inputFormatter]="reasonFormatter" [ngbTypeahead]="searchReason"
                                            [resultTemplate]="rt">
                                        <ng-template #rt let-r="result" let-t="term">
                                            <ngb-highlight [result]="r.reason" [term]="t"></ngb-highlight>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="onSaveClick()">Save</button>
</div>